import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-141" data-mp="1cf057fhu9cp3">
      <div className="mx-auto max-w-3xl" data-id="element-142" data-mp="1ccnf2f1xfw0y">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold text-navy-900 sm:text-4xl md:text-5xl" data-id="element-143" data-mp="2a2ia2f8dpunt">
          Frequently asked questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-144" data-mp="2042jqeh6epfd">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-ivory ring-1 ring-navy-900/10" data-id="element-145" data-mp="1v3y4ers080qq" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" data-id="element-146" data-mp="opp0xo1a5067">
                  <span className="text-base font-bold text-navy-900 sm:text-lg" data-id="element-147" data-mp="1pkgwfypaw1ko">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-148" data-mp="1arn95r3seh5g" />
                </button>
                <AnimatePresence initial={false} data-id="element-149" data-mp="16p0k1xyi3aby">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-150" data-mp="rzucnmpiedsz">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-151" data-mp="mywv9ccbpnsj">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCTA label="I'm Ready — Give Me Access" data-id="element-152" data-mp="2kulvojipclec" />
      </div>
    </section>;
}